import { render } from "./TransformFunctionField.vue?vue&type=template&id=58ebed77"
import script from "./TransformFunctionField.vue?vue&type=script&lang=js"
export * from "./TransformFunctionField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__